// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2tdcI","content":"styles_content__3RQs4","selectAll":"styles_selectAll__ilvxj"};